(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ab-claims"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Get popups by their specific IDs
    const returnsPopup = document.querySelector('#returns-popup');
    const warrantyPopup = document.querySelector('#warranty-popup');

    // Returns popup functionality
    const returnsButton = document.getElementById('footer-open-returns');
    if (returnsButton && returnsPopup) {
      returnsButton.addEventListener('click', function () {
        returnsPopup.classList.remove('ab:hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      });
    }

    // Warranty popup functionality
    const warrantyButton = document.getElementById('footer-open-warranty');
    if (warrantyButton && warrantyPopup) {
      warrantyButton.addEventListener('click', function () {
        warrantyPopup.classList.remove('ab:hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      });
    }

    // Shipping popup functionality
    const shippingButton = document.getElementById('footer-open-shipping');
    const shippingPopupEl = document.getElementById('shipping-popup');
    if (shippingButton && shippingPopupEl) {
      shippingButton.addEventListener('click', function (e) {
        e.preventDefault();
        shippingPopupEl.classList.remove('ab:hidden');
        if (typeof window.shipShowStep === 'function') {
          window.shipShowStep(1);
        }
        document.body.style.overflow = 'hidden';
      });
    }

    // General enquiry popup functionality
    const generalEnquiryButton = document.getElementById('show-form-wrapper');
    const generalQueryPopupEl = document.getElementById('general-enquiries-popup');
    if (generalEnquiryButton && generalQueryPopupEl) {
      generalEnquiryButton.addEventListener('click', function (e) {
        e.preventDefault();
        generalQueryPopupEl.classList.remove('ab:hidden');
        if (typeof window.gqShowStep === 'function') {
          window.gqShowStep(1);
        }
        document.body.style.overflow = 'hidden';
      });
    }

    // Close popup functionality (for both popups)
    const closeButtons = document.querySelectorAll('#closePopup');
    closeButtons.forEach(function (closeButton) {
      closeButton.addEventListener('click', function () {
        const popup = closeButton.closest('#returns-popup, #warranty-popup');
        if (popup) {
          popup.classList.add('ab:hidden');
          document.body.style.overflow = 'auto'; // Restore scrolling
        }
      });
    });

    // Close popup when clicking outside
    [returnsPopup, warrantyPopup].forEach(function (popup) {
      if (popup) {
        popup.addEventListener('click', function (e) {
          if (e.target === popup) {
            popup.classList.add('ab:hidden');
            document.body.style.overflow = 'auto'; // Restore scrolling
          }
        });
      }
    });

    // Close popup with Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const visiblePopup = document.querySelector(
          '#returns-popup:not(.ab\\:hidden), #warranty-popup:not(.ab\\:hidden)'
        );
        if (visiblePopup) {
          visiblePopup.classList.add('ab:hidden');
          document.body.style.overflow = 'auto'; // Restore scrolling
        }
      }
    });

    // Check URL parameters and open popups if needed
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('returns-popup') === 'true') {
      const returnsPopup = document.getElementById('returns-popup');
      if (returnsPopup) {
        returnsPopup.classList.remove('ab:hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      }
    }
    if (urlParams.get('warranty-popup') === 'true') {
      const warrantyPopup = document.getElementById('warranty-popup');
      if (warrantyPopup) {
        warrantyPopup.classList.remove('ab:hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      }
    }
    if (urlParams.get('general-query-popup') === 'true') {
      const generalQueryPopup = document.getElementById('general-enquiries-popup');
      if (generalQueryPopup) {
        generalQueryPopup.classList.remove('ab:hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      }
    }
    if (urlParams.get('shipping-popup') === 'true') {
      const shippingPopup = document.getElementById('shipping-popup');
      if (shippingPopup) {
        shippingPopup.classList.remove('ab:hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      }
    }
  });

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  } catch(e) { console.error(e); }
})();

})();
